import React from 'react';
import { generatePath, Link } from 'react-router-dom';
import { URLS } from 'services/urls';
import { Deal } from '../../types';

interface DealNameCellProps {
    deal: Deal;
}

const DealNameCell: React.FC<DealNameCellProps> = ({ deal }) => (
    <Link to={generatePath(URLS.DEAL_DASHBOARD.HOME, { dealId: deal.id || '' })}>{deal.dealName}</Link>
);

export default DealNameCell;
